<template>
  <router-view />
</template>

<script>
export default {
  name: "my-organization",
};
</script>
